import React from 'react';

import styled from '@emotion/styled';
import { atoms, TextareaField } from '@rtkwlf/fenrir-react';
import { Controller } from 'react-hook-form';

const TextArea = styled(TextareaField)({
  ':disabled': {
    cursor: 'not-allowed',
  },
});

const textareaClassName = atoms({
  backgroundColor: 'widgetDefault',
  borderColor: {
    default: 'neutralDefault',
    focus: 'brandDefault',
  },
  borderRadius: 'default',
  borderStyle: 'solid',
  borderWidth: 'default',
  focusOutline: {
    focusVisible: 'default',
  },
  fontFamily: 'body',
  fontSize: 'small',
  padding: 'small',
  textColor: 'body',
  width: 'full',
});

export const FormTextArea: React.FC<{
  control: any;
  isDisabled?: boolean | undefined;
}> = ({ control, isDisabled = false }) => (
  <Controller
    control={control}
    name="comment"
    render={({ field: { value, onChange, ...rest } }) => (
      <TextArea
        {...rest}
        name="comment"
        value={value}
        onChange={onChange}
        isDisabled={isDisabled}
        className={textareaClassName}
        rows={10}
      />
    )}
  />
);
